var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessageinline = function SvgMessageinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.375.002h10.688a2.377 2.377 0 0 1 2.374 2.375v7.125a2.377 2.377 0 0 1-2.374 2.375h-5.72l-3.988 3.421a.596.596 0 0 1-.98-.452v-2.969A2.377 2.377 0 0 1 0 9.502V2.377A2.377 2.377 0 0 1 2.375.002Zm1.781 3.562h7.125c.327 0 .594.268.594.594a.596.596 0 0 1-.594.594H4.156a.595.595 0 0 1-.593-.594c0-.326.267-.594.593-.594Zm4.75 2.375h-4.75a.595.595 0 0 0-.593.594c0 .327.267.594.593.594h4.75a.595.595 0 0 0 .594-.594.595.595 0 0 0-.594-.594Z",
    fill: "#BEB9D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 9.41V3.563A2.377 2.377 0 0 1 19 5.94v7.122a2.377 2.377 0 0 1-2.375 2.375v2.968a.591.591 0 0 1-.594.594.604.604 0 0 1-.386-.14l-3.989-3.422H5.937c-.304 0-.597-.06-.864-.163l2.612-2.246h5.337a3.615 3.615 0 0 0 3.603-3.618Z",
    fill: "#BEB9D7"
  })));
};
export default SvgMessageinline;